/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_SendingInputs */

const en_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const de_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet...`)
};

const fr_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi en cours...`)
};

const es_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

const it_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio...`)
};

const nl_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzenden...`)
};

const pl_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłanie...`)
};

const fi_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetetään...`)
};

const da_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender...`)
};

const sv_onboarding_verify_sending = /** @type {(inputs: Onboarding_Verify_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skickar...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Onboarding_Verify_SendingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_sending = /** @type {((inputs?: Onboarding_Verify_SendingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_SendingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_sending(inputs)
	if (locale === "fr") return fr_onboarding_verify_sending(inputs)
	if (locale === "es") return es_onboarding_verify_sending(inputs)
	if (locale === "it") return it_onboarding_verify_sending(inputs)
	if (locale === "nl") return nl_onboarding_verify_sending(inputs)
	if (locale === "pl") return pl_onboarding_verify_sending(inputs)
	if (locale === "fi") return fi_onboarding_verify_sending(inputs)
	if (locale === "da") return da_onboarding_verify_sending(inputs)
	if (locale === "sv") return sv_onboarding_verify_sending(inputs)
	return en_onboarding_verify_sending(inputs)
});